(function () {
  function runWhenSectionVisible(sectionEl, callback, options) {
    if (!sectionEl || typeof callback !== 'function') return;

    options = options || {};

    if (window.Shopify && window.Shopify.designMode) {
      callback();
      return;
    }

    if (!('IntersectionObserver' in window)) {
      callback();
      return;
    }

    var rootMargin = options.rootMargin || '200px 0px';
    var threshold = typeof options.threshold === 'number' ? options.threshold : 0.01;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          callback();
        });
      },
      { rootMargin: rootMargin, threshold: threshold }
    );

    observer.observe(sectionEl);
  }

  window.runWhenSectionVisible = runWhenSectionVisible;
})();
